import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  getIdData,
  addData,
  updateData,
} from "../../../lib/studentsupplemantalessay";
import TextEditor from "../../ui/editor";

export default function GlobalSupplementalEssayEdit() {
  const [college, setCollege] = useState();
  const [prompt, setPrompt] = useState();
  const [createdAt, setCreatedAt] = useState();
  const [instructorNote, setInstructorNote] = useState();
  const [studentNote, setStudentNote] = useState();
  const [essay, setEssay] = useState();
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const { slug, status, id } = useParams();

  const time = new Date().toLocaleString("en-US", {
    timeZone: "America/New_York",
  });

  console.log("Slug: ", slug, "Status: ", status, "Id: ", id);
  async function GetData() {
    //data
    const essayListData = await getIdData(id);
    console.log("parameterData", essayListData[0]);
    setData(essayListData);
    setCreatedAt(essayListData[0].created_at);
    setCollege(essayListData[0].college);
    setPrompt(essayListData[0].prompt);
    setInstructorNote(essayListData[0].InstructorNote);
    setStudentNote(essayListData[0].studentNote);
    setEssay(essayListData[0].essay);

    //isDisabled = {slug === "Add" ? false : true}
  }
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (status === "Add") {
      const newEssay = {
        studentId: slug,
        created_at: time,
        college: college,
        prompt: prompt,
        InstructorNote: instructorNote,
        studentNote: studentNote,
        essay: essay,
      };
      console.log("new essay: ", newEssay);
      try {
        await addData(newEssay);
        // navigate('/student/student-goal-questions');
        navigate(-1);
        // console.alert ('It will nevigate...')
      } catch (error) {
        console.error("There was an error adding the task!", error);
      }
    } else {
      const updatedEssay = {
        id: id,
        created_at: createdAt,
        studentId: slug,
        college: college,
        prompt: prompt,
        InstructorNote: instructorNote,
        studentNote: studentNote,
        essay: essay,
      };
      console.log("Updated Essay: ", updatedEssay);
      try {
        await updateData(updatedEssay);
        // navigate('/student/student-goal-questions');
        navigate(-1);
        // console.alert ('It will nevigate...')
      } catch (error) {
        console.error("There was an error adding the task!", error);
      }
    }
  };
  useEffect(() => {
    if (status === "Update") {
      GetData();
    }
  }, [status]);

  return (
    <div className="container mt-5">
      <h3>
        {status === "Add"
          ? "New Suplemental Essay"
          : "Update Suplemental Essay"}
      </h3>
      <form onSubmit={handleSubmit}>
        <div className="accordion" id="accordion">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button
                className="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                Supplemental Essay
              </button>
            </h2>
            <div
              id="collapseOne"
              className="accordion-collapse collapse show"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">
                <div className="form-floating mb-3">
                  <input
                    type="text"
                    className="form-control"
                    id="college"
                    placeholder="College Name"
                    value={college}
                    onChange={(e) => setCollege(e.target.value)}
                    required
                  />
                  <label htmlFor="college">College</label>
                </div>
                <div className="form-floating mb-3">
                  <input
                    type="text"
                    className="form-control"
                    id="prompt"
                    placeholder="Promt"
                    value={prompt}
                    onChange={(e) => setPrompt(e.target.value)}
                    required
                  />
                  <label htmlFor="prompt">Prompt</label>
                </div>
                <div className="form-floating mb-3">
                  <textarea
                    type="text"
                    className="form-control"
                    id="InstructorNote"
                    placeholder="Instructor's Note"
                    rows="3"
                    value={instructorNote}
                    onChange={(e) => setInstructorNote(e.target.value)}
                    required
                  ></textarea>
                  <label htmlFor="InstructorNote">Conselor&apos;s Note</label>
                </div>
                <div className="form-floating mb-3">
                  <textarea
                    type="text"
                    className="form-control"
                    id="studentNote"
                    placeholder="Student's Note"
                    rows="3"
                    value={studentNote}
                    onChange={(e) => setStudentNote(e.target.value)}
                    required
                  ></textarea>
                  <label htmlFor="studentNote">Student&apos;s Note</label>
                </div>
                <div className="form-floating mb-3">
                  <br></br>
                  <label htmlFor="editor">Essay</label>
                  <br></br>
                  <div id="editor">
                    <TextEditor value={essay} setValue={setEssay} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="update-profile d-flex justify-content-between">
          <button type="submit" className="btn btn-primary">
            {status === "Add"
              ? "Add Suplemental Essay"
              : "Update Suplemental Essay"}
          </button>
          <button
            type="button"
            className="btn btn-black btn-sm"
            onClick={() => navigate(-1)}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}
